<kt-portlet>
    <kt-portlet-header
        [title]="title$|async"
        [class]="'class-head-lg'"
        [sticky]="true"
    >
        <ng-container ktAdditionalTools>
            <div class="btn-group btn-group-toggle" role="group" ngbRadioGroup name="radioBasic" [formControl]="formSelectionCtrl">
                <label ngbButtonLabel class="btn btn-secondary width-130 btn-border-right-white">
                    <input class="btn-check" ngbButton type="radio" [value]="2" /> Simple
                </label>
                <label ngbButtonLabel class="btn btn-secondary width-130 btn-border-left-white">
                    <input class="btn-check" ngbButton type="radio" [value]="1" /> Advanced
                </label>
            </div>
        </ng-container>

        <ng-container ktPortletTools>
            <a [routerLink]="backUrl$|async" mat-raised-button class="btn mr-2">
                <mat-icon>arrow_back</mat-icon>
                <span>Close</span>
            </a>

            <button mat-raised-button color="warn" class="btn btn-success mr-2" style="background-color: orange !important;"
                (click)="onSubmit(false)"
            >
                <span>Save Draft</span>
            </button>

            <button mat-raised-button color="submit" class="btn btn-success mr-2" 
                (click)="onSubmit()"
            >
                <span>Save</span>
            </button>
        </ng-container>
    </kt-portlet-header>

    <kt-portlet-body>
        <app-hotel-comparable-form
            [assetClass]="assetClass$|async"
            [formType]="(formType$|async)!"
        ></app-hotel-comparable-form>
    </kt-portlet-body>
</kt-portlet>